module.exports = __webpack_public_path__ + "img/tips-img.e09b71fd.png";